"use client";

import { c as _c } from "react/compiler-runtime";
import { ClockCountdownIcon, CpuIcon, GaugeIcon, GearSixIcon, GraphIcon, WrenchIcon } from "@phosphor-icons/react";
import ManufacturingBeam from "../manufacturing-beam";
import { DesktopOnly } from "../ui/desktop-only";
const capabilities = [{
  icon: GaugeIcon,
  label: "Control de Calidad"
}, {
  icon: WrenchIcon,
  label: "Mantenimiento Predictivo"
}, {
  icon: CpuIcon,
  label: "Automatización"
}, {
  icon: GraphIcon,
  label: "Optimización"
}, {
  icon: ClockCountdownIcon,
  label: "Tiempo Real"
}, {
  icon: GearSixIcon,
  label: "Líneas de Producción"
}];
export default function ManufacturingSection() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DesktopOnly><div className="flex flex-1 items-center justify-center p-12"><ManufacturingBeam /></div></DesktopOnly>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 mb-2"><p className="text-xs font-mono text-background/50">MFG-4RP</p><div className="h-px flex-1 max-w-24 bg-background/20" /></div>;
    t2 = <h2 className="text-4xl md:text-5xl font-sans font-bold text-background mb-6">MANUFACTURA</h2>;
    t3 = <p className="text-sm font-mono text-background/70 leading-relaxed max-w-xl mb-8">Automatización inteligente para la industria del futuro. Nuestra plataforma monitoriza líneas de producción, predice mantenimiento preventivo y optimiza eficiencia operativa con IA en tiempo real.</p>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative w-full lg:min-h-screen bg-foreground overflow-hidden"><div className="flex flex-col lg:flex-row lg:min-h-screen pt-8 sm:pt-0">{t0}<div className="flex-1 px-6 py-16 pb-20 sm:px-12 sm:py-16 sm:pb-20 lg:p-20 flex flex-col justify-center shadow-xl">{t1}{t2}{t3}<div className="grid grid-cols-2 gap-2 max-w-md">{capabilities.map(_temp)}</div></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(t0) {
  const {
    icon: Icon,
    label
  } = t0;
  return <div key={label} className="flex items-center gap-2 border border-background/20 bg-background/5 px-3 py-2"><Icon className="size-4 text-background/70" weight="duotone" /><span className="text-xs font-mono text-background/80">{label}</span></div>;
}